import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { MethodologySections } from './components/MethodologySections';
import { OfferSection } from './components/OfferSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const META_PIXEL_ID = '1384540756930025';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: (...args: unknown[]) => void;
  loaded: boolean;
  version: string;
};
type PixelWindow = Window & {
  fbq?: MetaPixel;
  _fbq?: MetaPixel;
};
export function App() {
  useEffect(() => {
    const pixelWindow = window as PixelWindow;
    if (!pixelWindow.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue.push(args);
      } as MetaPixel;
      fbq.queue = [];
      fbq.push = (...args: unknown[]) => fbq.queue.push(args);
      fbq.loaded = true;
      fbq.version = '2.0';
      pixelWindow.fbq = fbq;
      pixelWindow._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      fbq('init', META_PIXEL_ID);
    }
    pixelWindow.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen w-full bg-ivory text-navy-950" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TestimonialsStrip data-id="element-4" />
        <MethodologySections data-id="element-5" />
        <OfferSection data-id="element-6" />
        <ExtendedTestimonials data-id="element-7" />
        <FAQ data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>
      <footer className="bg-navy-950 px-4 py-10 text-center text-blue-100" data-id="element-10">
        <p className="font-display text-base uppercase text-gold-300" data-id="element-11">
          ESL Teacher Ready™
        </p>
        <p className="mt-3 text-xs font-medium" data-id="element-12">
          © {new Date().getFullYear()} ESL Teacher Ready™ — All Rights
          Reserved.
        </p>
      </footer>
      <PurchaseNotifications data-id="element-13" />
    </div>;
}